import { Button, LinkButton, PublicButton } from '@yes.technology/react-toolkit'
import React from 'react'
import { Link } from 'react-router-dom'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { DataCardsButtonProps } from 'site/Renderer/components/DataCards/DataCards.types'

export type GenericObjectCardButtonProps = {
  buttonProps?: DataCardsButtonProps
  href: string
  label: string
  variant: 'primary' | 'secondary'
  linkTarget?: string
  enableFading?: boolean
}

const GenericObjectCardButton = ({
  buttonProps,
  href,
  label,
  variant,
  linkTarget,
  enableFading = false
}: GenericObjectCardButtonProps) => {
  if (isPublicButton(buttonProps)) {
    return (
      <PublicButton
        href={href}
        target={linkTarget}
        style={buttonProps?.style}
        {...getPublicButtonRest(buttonProps)}
      >
        {buttonProps?.label ?? label}
      </PublicButton>
    )
  }

  if (linkTarget !== undefined) {
    return (
      <LinkButton
        heightClass={buttonProps?.heightClass ?? 'small'}
        variant={buttonProps?.variant ?? variant}
        href={href}
        target={linkTarget}
        {...(buttonProps as Partial<React.ComponentProps<typeof LinkButton>>)}
        enableFading={enableFading}
      >
        {label}
      </LinkButton>
    )
  }

  return (
    <Link to={href} style={{ width: '100%', textDecoration: 'none' }}>
      <Button
        {...buttonProps}
        style={{ fontSize: '10px', ...buttonProps?.style }}
        heightClass={buttonProps?.heightClass ?? 'small'}
        variant={buttonProps?.variant ?? variant}
        enableFading={enableFading}
      >
        {label}
      </Button>
    </Link>
  )
}

export default GenericObjectCardButton
